import React, { useState, useEffect } from 'react';
import { Layout, Typography, Divider, BackTop, Tag } from 'antd';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import './index.css';

import { UserOutlined, CalendarOutlined, PushpinOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import moment from 'moment';
import { useParams } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;
const { Content } = Layout;

const PostDetail = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArticle = async () => {
      try {
        const storedArticles = JSON.parse(localStorage.getItem('articles')) || [];
        const article = storedArticles.find(article => article.id === id);
        
        if (article) {
          setPost(article);
        } else {
          setPost(null);
        }
      } catch (error) {
        console.error('加载文章失败:', error);
        setPost(null);
      } finally {
        setLoading(false);
      }
    };

    loadArticle();
  }, [id]);

  if (loading) {
    return (
      <Layout className="blog-layout">
        <AppHeader />
        <Content className="blog-content">
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <Title level={2}>加载中...</Title>
          </div>
        </Content>
        <AppFooter />
      </Layout>
    );
  }

  if (!post) {
    return (
      <Layout className="blog-layout">
        <AppHeader />
        <Content className="blog-content">
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <Title level={2}>文章不存在</Title>
            <Text type="secondary">您访问的文章可能已被删除或不存在。</Text>
            <div style={{ marginTop: '20px' }}>
              <a href="/archive" style={{ color: '#1890ff' }}>返回文章归档</a>
            </div>
          </div>
        </Content>
        <AppFooter />
      </Layout>
    );
  }

  return (
    <Layout className="blog-layout">
      <AppHeader />
      <Content className="blog-content">
        <div className="post-detail-container">
          <Title level={1} className="post-detail-title">{post.title}</Title>
          
          <div className="post-meta">
            <Text><UserOutlined /> 作者：{post.author || '匿名'}</Text>
            <Text><CalendarOutlined /> 日期：{moment(post.date).format('YYYY-MM-DD')}</Text>
            <Text><PushpinOutlined /> 标签：
              {post.tags && post.tags.map((tag, index) => (
                <Tag key={index} color="blue">{tag}</Tag>
              ))}
            </Text>
          </div>
          
          <Divider />
          
          <Paragraph className="markdown-body">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {post.content}
            </ReactMarkdown>
          </Paragraph>
        </div>
        <BackTop />
      </Content>
      <AppFooter />
    </Layout>
  );
};

export default PostDetail;